import * as React from 'react'

import DefaultListing from './default'
import PhotoduneListing from './photodune/gridContainer'

import { Site } from '../../../../common/constants/siteList'
import { IEnhancedLocation } from '../../../../common/reducers/reactRouterLocation'
import { IItem } from '../../../../typings/searchResults'

export interface IItemsListing {
  items: IItem[]
  itemDecorator: any
  location: IEnhancedLocation
  currentSite: Site
}

const ItemsListing = ({
  items,
  itemDecorator,
  location,
  currentSite
}: IItemsListing) => {
  const config = {
    [Site.photodune]: PhotoduneListing
  } as any

  const Listing = config[currentSite] || DefaultListing

  return (
    <Listing
      items={items}
      itemDecorator={itemDecorator}
      location={location}
      currentSite={currentSite}
    />
  )
}

export default ItemsListing
